export default "__VITE_ASSET__BlHEJMK2__"